export default "__VITE_ASSET__rKiOmIJE__"